module.exports = __webpack_public_path__ + "img/52.d4cd7f6c.webp";